/**
 * Created by Jerker Nord on 2021-01-28.
 */

import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {Oktoberfest} from "../Oktoberfest";
import {OktoberfestSound} from "../sound/OktoberfestSound";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {gsap} from "gsap";
import {ReelState} from "../../core/reel/ReelState";
import {OktoberfestReelController} from "../reels/OktoberfestReelController";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";

export class OktoberfestNormalBetPresentation implements FlowStatePresentation {

    private _normalStartDelay: number = 0.06;
    private _fastStartDelay: number = 0.01;

    constructor() {
    }

    public start(flowStateController: FlowStateController) {
        const tl = gsap.timeline({onComplete: () => flowStateController.finish()});
        tl.add(() => {
            Oktoberfest.betlines.onHideAllBetLines();
            Oktoberfest.background.onSpinStart();
            Oktoberfest.reelDividers.onSpinStart();
            Oktoberfest.leftIndicator.onSpinStart();
            Oktoberfest.foreground.playFrillAnimationUp();
        });
        tl.add(() => {
            Oktoberfest.initialCountUp.remove();
            OktoberfestSound.soundPlayer.playTrack({name: OktoberfestSound.REELS_SPINNING});
        });
        if (Oktoberfest.model.isRestore) {
            const isRespin: boolean = Oktoberfest.model.parsedInitData.mode === "WILD_RESPIN";
            const isNextModeNormal: boolean = Oktoberfest.model.parsedInitData.nextMode === GameMode.NORMAL;
            if (isRespin && !isNextModeNormal) {
                Oktoberfest.reels[1].reelState = ReelState.INACTIVE;
                Oktoberfest.reels[3].reelState = ReelState.INACTIVE;
                Oktoberfest.reels[2].reelState = ReelState.INACTIVE;
            } else {
                Oktoberfest.reels[1].reelState = ReelState.ACTIVE;
                Oktoberfest.reels[3].reelState = ReelState.ACTIVE;
                Oktoberfest.reels[2].reelState = ReelState.ACTIVE;
            }
            if (Oktoberfest.model.parsedInitData.mode === GameMode.FREESPIN) {
                Oktoberfest.reels.forEach((reel: OktoberfestReelController, reelId: number) => {
                    tl.add(reel.startSpin(true), ((APISetting.FAST_SPIN ? this._fastStartDelay : this._normalStartDelay) * reelId) + 0.5);
                });
            } else {
                tl.add(Oktoberfest.reels[0].startSpin(true), (APISetting.FAST_SPIN ? this._fastStartDelay : 0));
                tl.add(Oktoberfest.reels[4].startSpin(true), (APISetting.FAST_SPIN ? this._fastStartDelay : this._normalStartDelay) * 4);
            }
        } else {
            Oktoberfest.reels.forEach((reel: OktoberfestReelController) => {
                tl.add(reel.startSpin(true), (APISetting.FAST_SPIN ? this._fastStartDelay : this._normalStartDelay));
            });
        }
    }
}
